(() => {
  const init = (root) => {
    if (root.dataset.plSampleReady === 'true') return;
    root.dataset.plSampleReady = 'true';
    const form = root.querySelector('.pl-sample__form');
    const search = root.querySelector('[data-pl-sample-search]');
    const results = root.querySelector('[data-pl-sample-results]');
    const selectedList = root.querySelector('[data-pl-sample-selected]');
    const count = root.querySelector('[data-pl-sample-count]');
    const message = root.querySelector('[data-pl-sample-message]');
    const submit = root.querySelector('[data-pl-sample-submit]');
    const translationsNode = root.querySelector('[data-pl-sample-translations]');
    const i18n = translationsNode ? JSON.parse(translationsNode.textContent) : {};
    const format = (template, values = {}) => Object.entries(values).reduce(
      (result, [key, value]) => result.replaceAll(`{{ ${key} }}`, String(value)),
      template
    );
    const variantId = (root.dataset.sampleVariantId || '').trim();
    const configured = /^[1-9]\d*$/.test(variantId) && Number.isSafeInteger(Number(variantId));
    const cartUrl = root.dataset.cartUrl;
    const errorNotice = root.querySelector('[data-pl-sample-error]');
    const errorText = root.querySelector('[data-pl-sample-error-text]');
    const cartLink = root.querySelector('[data-pl-sample-cart-link]');
    let submitting = false;
    // An interrupted POST may still have succeeded. Never blindly repeat it.
    let addAttempted = false;
    const showError = (value, showCart = false) => {
      errorText.textContent = value;
      cartLink.hidden = !showCart;
      errorNotice.hidden = false;
    };
    const selected = [];
    const params = new URLSearchParams(window.location.search);
    const requestedProduct = params.get('product');
    const requestedVariant = params.get('variant');
    let products = [];
    let loading = null;
    let timer;
    let loaded = false;

    const text = (tag, className, value) => {
      const node = document.createElement(tag);
      node.className = className;
      node.textContent = value;
      return node;
    };
    const image = (src, title) => {
      if (!src) return text('span', 'pl-sample__image-placeholder', '');
      const node = document.createElement('img');
      node.src = src.replace(/(\.\w+)(\?.*)?$/, '_100x100$1$2');
      node.alt = '';
      node.loading = 'lazy';
      return node;
    };
    const label = (item) => item.variantTitle && item.variantTitle !== 'Default Title' ? `${item.title} — ${item.variantTitle}` : item.title;
    const sync = () => {
      count.textContent = `${selected.length}/3`;
      submit.disabled = submitting || !configured || selected.length === 0;
      message.textContent = selected.length === 3 ? i18n.maxReached : selected.length === 0 ? i18n.selectMinimum : format(i18n.selectedCount, { count: selected.length });
      selectedList.replaceChildren();
      selected.forEach((item) => {
        const row = text('div', 'pl-sample__selected-row', '');
        row.append(image(item.image, item.title));
        const details = text('span', 'pl-sample__item-text', item.title);
        if (item.variantTitle && item.variantTitle !== 'Default Title') details.append(text('small', '', item.variantTitle));
        row.append(details);
        const remove = text('button', 'pl-sample__remove', '×');
        remove.type = 'button';
        remove.disabled = submitting;
        remove.setAttribute('aria-label', format(i18n.remove, { product: label(item) }));
        remove.addEventListener('click', () => {
          if (submitting) return;
          selected.splice(selected.findIndex((entry) => entry.variantId === item.variantId), 1);
          sync();
          renderResults();
        });
        row.append(remove);
        selectedList.append(row);
      });
    };
    const load = () => {
      if (loading) return loading;
      if (!root.dataset.collectionUrl) {
        message.textContent = i18n.collectionMissing;
        return Promise.resolve();
      }
      loading = (async () => {
        let page = 1;
        while (true) {
          const response = await fetch(`${root.dataset.collectionUrl}/products.json?limit=250&page=${page}`, { credentials: 'same-origin' });
          if (!response.ok) throw new Error('Producten konden niet geladen worden');
          const data = await response.json();
          products.push(...(data.products || []));
          renderResults();
          if (!data.products || data.products.length < 250) break;
          page += 1;
        }
        loaded = true;
        if (requestedProduct) {
          const product = products.find((entry) => entry.handle === requestedProduct);
          const variant = product?.variants?.find((entry) => String(entry.id) === requestedVariant) || product?.variants?.[0];
          if (!submitting && selected.length < 3 && product && variant && !selected.some((entry) => entry.variantId === variant.id)) {
            selected.push({ productId: product.id, variantId: variant.id, title: product.title, variantTitle: variant.title || '', image: variant.featured_image?.src || product.image?.src || product.images?.[0]?.src || '' });
            sync();
            renderResults();
          }
        }
      })().catch(() => { results.replaceChildren(text('p', 'pl-sample__selection-message', i18n.loadFailed)); loading = null; });
      return loading;
    };
    const renderResults = () => {
      const locale = document.documentElement.lang || 'en';
      const query = search.value.trim().toLocaleLowerCase(locale);
      results.replaceChildren();
      const matches = [];
      for (const product of products) {
        for (const variant of product.variants || []) {
          const title = variant.title || '';
          if (!query || `${product.title} ${title} ${product.vendor || ''} ${variant.sku || ''}`.toLocaleLowerCase(locale).includes(query)) {
            matches.push({ productId: product.id, variantId: variant.id, title: product.title, variantTitle: title, image: variant.featured_image?.src || product.image?.src || product.images?.[0]?.src || '' });
          }
          if (matches.length >= (query ? 30 : 8)) break;
        }
        if (matches.length >= (query ? 30 : 8)) break;
      }
      if (!matches.length) results.append(text('p', 'pl-sample__selection-message', i18n.noneFound));
      matches.forEach((item) => {
        const button = text('button', 'pl-sample__result', '');
        button.type = 'button';
        const alreadySelected = selected.some((entry) => entry.variantId === item.variantId);
        button.disabled = submitting || selected.length >= 3 || alreadySelected;
        button.append(image(item.image, item.title));
        const details = text('span', 'pl-sample__item-text', item.title);
        if (item.variantTitle && item.variantTitle !== 'Default Title') details.append(text('small', '', item.variantTitle));
        button.append(details, text('span', 'pl-sample__result-action', alreadySelected ? i18n.added : i18n.add));
        button.addEventListener('click', () => {
          if (submitting || selected.length >= 3 || selected.some((entry) => entry.variantId === item.variantId)) return;
          selected.push(item);
          sync();
          renderResults();
        });
        results.append(button);
      });
      if (!query && matches.length) {
        const more = text('button', 'pl-sample__more', i18n.searchMore);
        more.type = 'button';
        more.setAttribute('aria-label', i18n.searchMoreAria);
        more.addEventListener('click', () => {
          search.scrollIntoView({ behavior: 'smooth', block: 'center' });
          search.focus({ preventScroll: true });
        });
        results.append(more);
      }
    };
    search.addEventListener('input', () => {
      clearTimeout(timer);
      timer = setTimeout(async () => { await load(); renderResults(); }, 150);
    });
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (submitting) return;
      if (!configured) { showError(i18n.configurationError); return; }
      if (!selected.length || selected.length > 3 || new Set(selected.map((item) => item.variantId)).size !== selected.length) {
        message.textContent = i18n.selectMinimum;
        search.focus();
        return;
      }
      const properties = { _sample_pack: 'true' };
      selected.forEach((item, index) => {
        // Stable Dutch property names keep fulfilment consistent across storefront languages.
        properties[`Staaltje ${index + 1}`] = label(item);
        properties[`_sample_variant_${index + 1}`] = String(item.variantId);
      });
      const matchesPack = (item) => String(item.variant_id) === variantId && item.quantity === 1 &&
        Object.keys(item.properties || {}).length === Object.keys(properties).length &&
        Object.entries(properties).every(([key, value]) => item.properties?.[key] === value);
      const readCart = async () => {
        const response = await fetch(`${cartUrl}.js`, { credentials: 'same-origin', cache: 'no-store' });
        if (!response.ok) throw new Error(i18n.checkoutError);
        const cart = await response.json();
        if (!Array.isArray(cart.items)) throw new Error(i18n.checkoutError);
        return cart;
      };
      submitting = true;
      errorNotice.hidden = true;
      form.setAttribute('aria-busy', 'true');
      sync();
      renderResults();
      message.textContent = i18n.processing;
      try {
        let cart = await readCart();
        if (cart.items.length && !(cart.items.length === 1 && matchesPack(cart.items[0]))) {
          throw new Error(i18n.cartOccupied);
        }
        if (!cart.items.length) {
          if (addAttempted) throw new Error(i18n.checkoutError);
          addAttempted = true;
          const response = await fetch(`${cartUrl}/add.js`, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties }] })
          });
          if (!response.ok) throw new Error(response.status === 404 || response.status === 422 ? i18n.configurationError : i18n.checkoutError);
          const added = await response.json();
          if (added.items?.length !== 1 || !matchesPack(added.items[0])) throw new Error(i18n.checkoutError);
          cart = await readCart();
        }
        // Recheck before checkout, including changes made in another tab.
        if (cart.items.length !== 1 || !matchesPack(cart.items[0])) throw new Error(i18n.cartOccupied);
        if (cart.items[0].original_price !== 0 || cart.items[0].requires_shipping !== true) {
          throw new Error(i18n.configurationError);
        }
        window.location.assign(`${cartUrl}/checkout`);
      } catch (error) {
        showError(error.message === i18n.cartOccupied || error.message === i18n.configurationError ? error.message : i18n.checkoutError, true);
        submitting = false;
        form.removeAttribute('aria-busy');
        sync();
        renderResults();
      }
    });
    window.addEventListener('pageshow', (event) => {
      if (!event.persisted) return;
      submitting = false;
      form.removeAttribute('aria-busy');
      sync();
      renderResults();
    });
    if (!configured) showError(i18n.configurationError);
    sync();
    load().then(() => { if (loaded) renderResults(); });
  };
  document.querySelectorAll('[data-pl-sample]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-pl-sample]').forEach(init));
})();
